import React, { useRef, useEffect, useState } from "react";
import Results from "./Results";
import SearchInput from "./SearchInput";
import useKeyPress from "./useKeyPress";
import { gsap } from "gsap";

export default function Modal({ openModal, setOpenModal }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [headerHeight, setHeaderHeight] = useState(183);
  const modalRef = useRef(null);
  const escapePressed = useKeyPress("Escape");
  const inputRef = useRef(null);

  useEffect(() => {
    if (openModal) {
      // modalRef.current?.showModal();
      modalRef.current?.show(); // non modal dialog, so we can show Header nav
      gsap
        .fromTo(
          ".search-modal",
          { y: -100, autoAlpha: 0 },
          { y: 0, autoAlpha: 1, duration: 0.35 }
        )
        .then(() => {
          inputRef.current?.focus();
        });
      console.log("focus meeeee", inputRef.current);
    } else {
      modalRef.current?.close();
    }
    // calculate height of header, save to var?
    setHeaderHeight(document.querySelector(".header").offsetHeight);
  }, [openModal]);

  // since this is a non-modal dialog, we need to add listener on escape key
  useEffect(() => {
    if (escapePressed) {
      setOpenModal(false);
    }
  }, [escapePressed]);

  useEffect(() => {
    // click outside modal to close
    const handleClick = (event) => {
      if (event.target.id == "main") {
        setOpenModal(false);
      }
    };

    const handleResize = (event) => {
      if (event.currentTarget.innerWidth > 1100) {
        setOpenModal(false);
      }
    };

    window.addEventListener("click", handleClick);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("click", handleClick);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const modalHeight = searchTerm ? `calc(100vh - ${headerHeight}px)` : "auto";

  return (
    <dialog
      className="search-modal"
      ref={modalRef}
      onCancel={() => setOpenModal(false)}
      style={{ height: modalHeight, top: headerHeight }}
    >
      <div className="search-modal-header-container">
        <div className="search-modal-header">
          <SearchInput
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            inputRef={inputRef}
          />
          <button
            className="button search-modal-close"
            onClick={() => setOpenModal(false)}
          >
            Close
          </button>
        </div>
      </div>
      <Results searchTerm={searchTerm} />
    </dialog>
  );
}
